import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { cn } from "../utils";

// TODO: Isn't animate-pulse a better loading animation?
import { jsx as _jsx } from "react/jsx-runtime";
function Skeleton(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-skeleton tw-relative tw-flex tw-overflow-hidden tw-rounded-1 tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600', className)
  }, props));
}
export { Skeleton };